import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Card, CardBody } from 'reactstrap'
import { connect, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import { JobForm } from '../JobForm'
import { JOB_STATUS } from 'features/job/consts/general'
import { useNotify } from 'hooks'
import { DataShower } from 'components/Elements'
import { jobEditData, jobEditSubmitPA } from 'features/job/store'
import { useUserPermissions } from 'features/user/hooks'
import { useJobPosting } from 'features/job/hooks'

export const JobEditComponent = props => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { showNotification } = useNotify()
  const { isJobPostingAllow } = useUserPermissions()
  const { onPostingSuccess } = useJobPosting()

  const { id } = useParams()

  useEffect(() => {
    dispatch(jobEditData.getData({ id }))

    return () => {
      dispatch(jobEditData.cleanState({}))
    }
  }, [])

  const onSubmit = async values => {
    const jobStatus = props.data?.status
    const { status } = values

    await dispatch(jobEditSubmitPA.request({ id, params: values }))

    let route
    let message

    if (status === JOB_STATUS.ACTIVE) {
      message = t('saved_successfully')
      route = '/jobs/my/active'

      if (jobStatus === JOB_STATUS.DRAFT) {
        message = t('job_posted_successfully')

        onPostingSuccess(props.data)
      }
    } else {
      message = t('saved_to_draft_successfully')
      route = '/jobs/my/drafts'
    }

    showNotification({
      type: 'success',
      message: message,
    })

    navigate(route)
  }

  const initialValues = useMemo(() => {
    let result = {}

    if (props.data) {
      const {
        location_province,
        location_city,
        pay_range_min,
        pay_range_max,
        profile_experience_year,
        job_type,
        profile_study_program,
        profile_study_area,
        languages,
        skills,
        ...restData
      } = props.data
      result = {
        location_province_id: location_province?.id || null,
        location_city_id: location_city?.id || null,
        profile_experience_year_id: profile_experience_year?.id,
        pay_range_min: pay_range_min !== null ? pay_range_min.toString() : '',
        pay_range_max: pay_range_max !== null ? pay_range_max.toString() : '',
        job_type_id: job_type?.id,
        profile_study_program_id: profile_study_program?.id,
        profile_study_area_id: profile_study_area?.id,
        languages: languages ? languages.map(item => item.id) : [],
        skills: skills ? skills.map(item => item.id) : [],
        ...restData,
      }
    }

    return result
  }, [props.data])

  return (
    <>
      <Card>
        <CardBody>
          <DataShower
            isLoading={props.loading}
            isFetched={!!props.data}
            isFailed={!!props.error}
            error={props.error}
          >
            <JobForm
              initialValues={initialValues}
              onSubmit={onSubmit}
              isEdit
              isPostingAllow={isJobPostingAllow(props.data)}
            />
          </DataShower>
        </CardBody>
      </Card>
    </>
  )
}

JobEditComponent.propTypes = {}

const mapStateToProps = state => {
  const { data, loading, error } = state.job.edit.data
  return {
    data,
    loading,
    error,
  }
}

export const JobEdit = connect(mapStateToProps)(JobEditComponent)
